module.exports = __webpack_public_path__ + "img/placeholder.e091de57.png";